import { render, staticRenderFns } from "./SuccessScreen.component.vue?vue&type=template&id=0f586f7b&scoped=true"
import script from "./SuccessScreen.component.vue?vue&type=script&lang=js"
export * from "./SuccessScreen.component.vue?vue&type=script&lang=js"
import style0 from "./SuccessScreen.component.vue?vue&type=style&index=0&id=0f586f7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f586f7b",
  null
  
)

export default component.exports